if (typeof window !== 'undefined') {
  window.autoUpdateMap = new Map()
  window.autoUpdateEnabled = false

  window.autoUpdater = {
    newArray: [],
    executeArray: [],
    clearArray: [],
    updatingMap: {},
    animatePeriod: 9000,
    lastFetch: Date.now(),
    lastPush: Date.now(),
    totalLength: 0,
    animateInterval: null,
    mainInterval: null,
    clearLeaves() {
      this.newArray = []
      this.executeArray = []
      this.clearArray = []
    },
    push(leaveUpdate) {
      this.newArray.push(leaveUpdate)
      this.lastPush = Date.now()
    },
    clearLeaf(clearedItem) {
      const { ref, animationBg, animation } = clearedItem
      if (!ref) {
        return
      }

      ref.classList.remove(animationBg)

      for (let i = 0; i < ref.children.length; i++) {
        const item = ref.children[i]
        if (!item.classList.contains('Leaf__Name')) {
          item.classList.remove(animation)
        }
      }
    },
    animateLeaf(leafInstruction) {
      const { ref, animationBg, animation, price, change, dominance, symbol } =
        leafInstruction

      if (!ref) {
        return
      }

      if (window.autoUpdateEnabled) {
        this.updatingMap[symbol] = true
        ref.classList.add(animationBg)
      }

      for (let i = 0; i < ref.children.length; i++) {
        const item = ref.children[i]
        if (item.classList.contains('Leaf__Price')) {
          item.innerHTML = price
        }

        if (item.classList.contains('Leaf__Change')) {
          item.innerHTML = change
        }

        if (item.classList.contains('Leaf__Dominance')) {
          item.innerHTML = dominance
        }

        if (
          !item.classList.contains('Leaf__Name') &&
          window.autoUpdateEnabled
        ) {
          item.classList.add(animation)
        }
      }

      if (window.autoUpdateEnabled) {
        leafInstruction.timestamp = Date.now()
        this.clearArray.push(leafInstruction)
      }
    },
    executeUpdate() {
      const instructions = this.executeArray.splice(0, 1)[0]

      if (instructions) {
        const { symbol, type } = instructions
        if (!this.updatingMap[symbol] || !window.autoUpdateEnabled) {
          if (type === 'leaf') {
            this.animateLeaf(instructions)
          }
        }
      }

      const firstClear = this.clearArray[0]

      if (firstClear && Date.now() - firstClear.timestamp >= 4000) {
        const clearedItem = this.clearArray.shift()
        const { symbol, type } = clearedItem
        delete this.updatingMap[symbol]

        if (type === 'leaf') {
          this.clearLeaf(clearedItem)
        }
      }
    },
    execute() {
      this.animateInterval = setInterval(() => {
        this.executeUpdate()

        if (
          this.executeArray.length < this.totalLength * 0.2 &&
          !this.newArray.length &&
          this.canFetch()
        ) {
          this.fetching()
        }
      }, this.animatePeriod / this.executeArray.length)
    },
    fetching() {
      this.isFetching = true
      this.lastFetch = Date.now()
    },
    canFetch() {
      return !this.isFetching && Date.now() - this.lastFetch > 4000
    },
    fetchEnd() {
      this.isFetching = false
    },
    toggleAutoUpdate(isEnabled) {
      window.autoUpdateEnabled = isEnabled
    },
    stop() {
      clearInterval(this.animateInterval)
      clearInterval(this.mainInterval)
      this.executeArray = []
      this.newArray = []
    },
    start() {
      this.newArray = []
      this.executeArray = []

      this.mainInterval = setInterval(() => {
        if (
          !this.executeArray.length &&
          !this.newArray.length &&
          this.canFetch()
        ) {
          this.fetching()
        }

        if (
          Date.now() - this.lastPush > 500 &&
          this.newArray.length &&
          !this.executeArray.length
        ) {
          this.executeArray = this.executeArray.concat(
            this.newArray.sort(() => Math.random() - 0.5)
          )
          this.newArray = []
          this.totalLength = this.executeArray.length
          clearInterval(this.animateInterval)
          this.animateInterval = 0
        }

        if (!this.animateInterval && this.executeArray.length) {
          this.execute()
        }
      }, 200)
    },
  }
}
